import React from 'react'
import { Typography, Grid2 as Grid } from '@mui/material'
import Banner from 'components/Banner'

interface ISepsesRiskBannerProps {
  overallHealth: number
  overallHealthColor: string
  overallHealthWarning: number
}

const SepsesRiskBanner: React.FC<ISepsesRiskBannerProps> = ({
  overallHealth,
  overallHealthColor,
  overallHealthWarning
}) => {
  if (
    !(
      (overallHealth != 0 && overallHealth != null && overallHealth <= 75) ||
      overallHealthWarning == 1
    )
  )
    return <React.Fragment />

  let recommendation = 'Intervenção médica'

  if (overallHealth > 65 && overallHealth <= 75) {
    recommendation = 'Avaliação de Sepse'
  } else if (overallHealth <= 65) {
    recommendation = 'Escalonar cuidados imediatamente'
  }

  return (
    <Grid container mb={2}>
      <Grid size={12}>
        <Banner
          variant='filled'
          sx={{
            backgroundColor: `rgba(${overallHealthColor})`
          }}
        >
          <Typography variant='h5' fontWeight='bold'>
            Pontuação geral de saúde
          </Typography>
          <Typography variant='subtitle1' fontWeight='bold'>
            Recomendação:
          </Typography>
          <Typography variant='body1'>{recommendation}</Typography>
        </Banner>
      </Grid>
    </Grid>
  )
}

export default SepsesRiskBanner
